import { useQuery } from '@tanstack/react-query'
import { Api } from '../store'
import { keys } from './keys'

/**
 * Branding for every visitor, including the sign-in page and basic users.
 * Branding changes through Global settings, whose save invalidates this query; changes made
 * in another browser show after a reload.
 */
export const useBranding = () =>
  useQuery({
    queryKey: keys.settings.branding,
    queryFn: () => Api.brandingApi.getBranding(),
    staleTime: Infinity,
    // Logos render nothing rather than the default while branding is unknown, so a toast adds nothing
    meta: { operation: 'fetch branding', silent: true },
  })
